var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.footerContent)?_c('v-footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-wrapper v-main"},[_c('div',{staticClass:"footer-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.parsedFooterContent)}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }